import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { GradientBackground } from "@/components/ui/gradient-background";
import { BRAND_NAME } from "@/lib/constants/brand";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/onboarding/welcome")({
	component: WelcomePage,
});

function WelcomePage() {
	const navigate = useNavigate();

	return (
		<>
			<GradientBackground />
			<div className="relative flex flex-col items-center justify-center">
				<div className="flex max-w-sm flex-col items-center px-4 py-16 text-center">
					{/* Logo with gradient overlay effect */}
					<div
						className={cn(
							"animate-slide-up-fade relative flex w-auto items-center justify-center px-6 py-2",
							"[--offset:20px] animation-duration-[1.3s]",
						)}
					>
						<Gradient className="opacity-10 mix-blend-overlay" />
						<span className="relative text-4xl font-bold sm:text-5xl">
							{BRAND_NAME}
						</span>
						<Gradient className="opacity-50 mix-blend-hard-light" />
					</div>

					<h1
						className={cn(
							"animate-slide-up-fade mt-14 text-xl font-semibold text-neutral-900",
							"[--offset:10px] [animation-delay:250ms] animation-duration-[1s]",
						)}
					>
						Welcome to {BRAND_NAME}
					</h1>

					<p
						className={cn(
							"animate-slide-up-fade mt-2 text-balance text-base text-neutral-500",
							"[--offset:10px] [animation-delay:500ms] animation-duration-[1s]",
						)}
					>
						Set up your point-of-sale system in minutes. Let's create your first
						organization.
					</p>

					<div
						className={cn(
							"animate-slide-up-fade mt-8 w-full",
							"[--offset:10px] [animation-delay:750ms] animation-duration-[1s]",
						)}
					>
						<Button
							className="w-full"
							onClick={() => navigate({ to: "/onboarding/consent" })}
						>
							Get started
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}

function Gradient({ className }: Readonly<{ className?: string }>) {
	return (
		<div
			className={cn(
				"absolute inset-y-0 left-1/2 aspect-square -translate-x-1/2",
				className,
			)}
		>
			<div className="size-full scale-x-[-1.8] blur-2xl">
				<div
					className={cn(
						"size-full -rotate-90 saturate-[3]",
						"bg-[conic-gradient(from_279deg,#EAB308_47deg,#F00_121deg,#00FFF9_190deg,#855AFC_251deg,#3A8BFD_267deg,#A3ECB3_314deg,#EAB308_360deg)]",
					)}
				/>
			</div>
		</div>
	);
}
